import React, { useMemo } from 'react';
import { Box, Inscription, NotVisibleICount } from '@common-fe/common-fe';

interface LockCardPurseCardProps {
  planIdsForCardPurseLock?: string[];
  planNamesForCardPurseLock?: string[];
}

export const LockCardPurseCard: React.FC<LockCardPurseCardProps> = ({
  planIdsForCardPurseLock = [],
  planNamesForCardPurseLock = [],
}) => {
  const isLocked = planIdsForCardPurseLock.length > 0;
  const actionLabel = isLocked ? 'Lock' : 'Unlock';

  const lockCardPurseOptions = useMemo(
    () => planNamesForCardPurseLock.map((name) => ({ key: name, value: name })),
    [planNamesForCardPurseLock]
  );

  return (
    <Box width="65%">
      <Inscription color="textBody" size="large" lineHeight="22px" margin={{ bottom: 's' }}>
        Lock card purse
      </Inscription>
      <Box background="module" pad="s" round="container1Round">
        <Box
          pad={{ vertical: 'm', horizontal: '20px' }}
          round="container2Round"
          background="canvas"
          border={{ color: 'border2', size: '1px' }}
          height="52px"
          direction="row"
          align="center"
          justify="between"
        >
          <Inscription color="textBody" lineHeight="20px" style={{ flexShrink: 0 }}>
            {actionLabel}
          </Inscription>
          {isLocked && planNamesForCardPurseLock.length > 0 && (
            <Box margin={{ left: 'spacing32' }}>
              <NotVisibleICount options={lockCardPurseOptions} boxStyle={{ margin: 0 }} hintOnly />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
